import styled from "styled-components";

import { theme } from "../../themes/themes";
export const AnswerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 8fr;
  justify-items: stretch;
  align-content: center;
  align-items: center;

  input[type="radio"] {
    justify-self: center;
    width: 55%;
    height: 2em;
    outline: 0;
  }
  input[type="checkbox"] {
    justify-self: center;
    width: 55%;
    height: 2em;
    outline: 0;
  }

  input[type="text"] {
    padding: 0.3em;
    width: 100%;
    border: none;
    outline: 0;
    box-sizing: border-box;
  }
`;
export const UploadImageContainer = styled.div`
  margin: 0px;
  width: 90% !important;
  height: 100%;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;
  border-top: none;
  margin-top: 10px;
  margin-left: 50px;
`;

export const ShowImageContainer = styled.img`
  width: 90% !important;
  height: 100%;
`;
